module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email input-view",
    attrs: {
      "type": "text",
      "list": "email-list",
      "placeholder": "Enter your Email or Phone Number"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-vp"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password input-view",
    attrs: {
      "type": "password",
      "placeholder": "Enter your password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rememberpw),
      expression: "!rememberpw"
    }],
    staticClass: "rememberpw",
    attrs: {
      "src": require("../assets/images/rememberpw_off@2x.png"),
      "title": "Remember your password"
    },
    on: {
      "click": function($event) {
        _vm.rememberpw = !_vm.rememberpw
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rememberpw),
      expression: "rememberpw"
    }],
    staticClass: "rememberpw",
    attrs: {
      "src": require("../assets/images/rememberpw_on@2x.png"),
      "title": "Don't remember your password"
    },
    on: {
      "click": function($event) {
        _vm.rememberpw = !_vm.rememberpw
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/forgot"
    }
  }, [_vm._v("Forgot Password")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/qrcode"
    }
  }, [_c('div', {
    staticClass: "change"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_qrcode@2x.png"),
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo1@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c4fa586"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 727
// module chunks = 1